import { render, staticRenderFns } from "./comment_strategy_keyword.vue?vue&type=template&id=4d4f9b9b"
import script from "./comment_strategy_keyword.vue?vue&type=script&lang=js"
export * from "./comment_strategy_keyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports